import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import request from 'actions/request';

class DataProvider extends Component {
  componentDidMount() {
    this.requestGeo();
  }

  componentDidUpdate() {
    this.requestGeo();
  }

  requestGeo() {
    if (this.shouldRequestGeo()) {
      this.props.request(
        ['trackData', 'getGeo'],
        'get',
        'TRACK_GEO',
        { trackId: this.props.trackId }
      );
    }
  }

  shouldRequestGeo() {
    if (((this.props.geoTrackId !== this.props.trackId)
      || (this.props.status === null))
      && (this.props.status !== 'pending')
    ) {
      return true
    }

    return false;
  }

  render() {
    return null;
  }
}

DataProvider.propTypes = {
  trackId: PropTypes.number.isRequired,
};


function mapStateToProps(state) {
  return {
    status: state.realtimePlayback.status,
    geoTrackId: state.realtimePlayback.trackId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataProvider);
